export default __webpack_public_path__ + "static/media/icon.68ac3c4b.png";